module.exports = __webpack_public_path__ + "img/finish_quantum.715262e7.png";